module.exports = __webpack_public_path__ + "static/media/5.39fd9f61.png";